export default "__VITE_ASSET__5660d017__"